import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0a0908] border-t border-[rgba(242,207,139,0.18)] py-14">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          <div>
            <img src="/assets/epsom-logo.webp" alt="Epsom" className="h-14 w-auto brightness-0 invert opacity-80 mb-4" />
            <p className="text-sm text-[#93897d] leading-relaxed max-w-xs">
              Premium wellness, recovery, aesthetics and spa experiences across Mumbai.
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-[#d9cdbb] uppercase tracking-wider mb-4">Locations</h4>
            <ul className="space-y-3 text-sm text-[#93897d]">
              {["Santacruz West", "Borivali West", "Andheri West"].map((loc) => (
                <li key={loc} className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-[#d7a85c]" />{loc}</li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-[#d9cdbb] uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-[#93897d]">
              <li className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-[#d7a85c]" /><a href="tel:+919867670764" className="hover:text-[#f2cf8b] transition-colors">+91 9867670764</a></li>
              <li className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-[#d7a85c]" /><a href="tel:+919867670762" className="hover:text-[#f2cf8b] transition-colors">+91 9867670762</a></li>
              <li className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-[#d7a85c]" /><a href="mailto:info@epsomcryospa.com" className="hover:text-[#f2cf8b] transition-colors">info@epsomcryospa.com</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[rgba(242,207,139,0.18)] pt-6 text-xs text-[#93897d]">
          © {new Date().getFullYear()} Epsom Wellness & Aesthetics. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
